import i18next from 'i18next'
import { contactProfileFields } from '../../common/forms/contacts/fields'
import { Tab } from '../../types/global'

export const contactFormTabs = (isEdit: boolean): Tab[] => {
    const { t } = i18next
    return [
        { id: 1, name: 'general', label: t('app.common.generalInfo') },
        { id: 2, name: 'otherInfo', label: t('app.common.otherInfo'), disabled: !isEdit },
        { id: 3, name: 'demand', label: t('app.common.contact.demandProfile'), disabled: !isEdit },
        { id: 4, name: 'documents', label: t('app.common.documents'), disabled: !isEdit },
    ]
}

export const contactViewTabs = (): Tab[] => {
    const { t } = i18next
    const tabs = [
        { id: 1, name: 'general', label: t('view.contact.tab.general') },
        { id: 2, name: 'demand', label: t('app.common.contact.demandProfile') },
        { id: 3, name: 'offer', label: t('app.common.contact.offerProfile') },
        { id: 4, name: 'documents', label: t('app.common.documents') },
        { id: 5, name: 'inDepthAnalysis', label: 'Dubinska analiza' },
    ]
    return tabs
}

// fields to normalize for decimal number display
export const fieldsToNormalize = [
    contactProfileFields.PRICE_FROM,
    contactProfileFields.PRICE_TO,
    contactProfileFields.AREA_FROM,
    contactProfileFields.AREA_TO,
]
